module.exports = __webpack_public_path__ + "static/media/apresentador.98afe772.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/apresentador.png
// module id = 221
// module chunks = 0